export enum Locale {
    Ru = 'ru',
    En = 'en',
}
